<svg:g class="step">
    <path [attr.d]="path" [style.stroke-width]="highlight ? 0.2 : 0.1" [style.stroke]="color"></path>
    <text [attr.x]="-15" [attr.y]="titleY" [style.fill]="color" [style.font-size]="highlight ? '0.21em' : '0.2em'">
        {{ title }}
    </text>
</svg:g>
